import { createGlobalConfig } from '@wix/panorama-client-web';

export const globalConfig = createGlobalConfig();
